// extracted by mini-css-extract-plugin
module.exports = {"list":"PricingMenuItemList_list__DkQAW","see-more":"PricingMenuItemList_see-more__CZIUa"};